import * as types from "@/store/constants/types";
import Http from "@/api/http/fetch/index";
import * as gxConst from "@/api/http/gx/gxConst";
import * as gxRequest from "@/api/http/gx/gxBase";
import GeneralUtilsHelper from "@/utils/generalUtils";
import store from "@/store/index";
import MD5 from "crypto-js/md5";
import localStorageHelper from "@/localstorage/localstorage";
import {
  sendEvent,
  sendGXError,
  superPayResponse,
  sendGXSuccess
} from "@/utils/analytics";
import EventBus from "@/utils/eventBus";
import { eventObj, updateEventObj } from "@/utils/sendEventUtil";
import LaunchUtils from "@/utils/launchUtils";
import { getAppVersion, isIos } from "@/utils/lodash";
import { judgeVersion } from "@/utils/judgeVersion";

let cacheParams: any = null;

export const defaultTransactionId = () => {
  return `${store.getters[types.GETTER_MASTER_ID]}${new Date().getTime()}`;
};

const sendRecomdOfferEvent = () => {
  const eventData = store.getters[types.GETTER_RECOMMEND_ORDER_STATUS];
  if (eventData) {
    sendEvent(eventData.key, eventData.value);
  }
};

const getPaypalClientId = () => {
  return MD5(
    store.getters[types.GETTER_SETTING_DATA].paypal.paypal_sdk_client_id
  )
    .toString()
    .toLowerCase();
};

const getDeviceInfo = async () => {
  //增加device_info字段:
  //安卓：从deviceId里面获取:  ANDROID_ID GOOGLE_AD_ID
  //IOS : idfv GetIDFV
  const device_id = store.getters[types.GETTER_MASTER_ID];
  const device_info: any = {
    customer_user_id: device_id
  };

  if (isIos()) {
    const idfv_result: any = await store.dispatch(types.GETTER_IDFV);
    device_info.idfa = device_id;
    if (idfv_result) {
      device_info.idfv = idfv_result;
    }
  } else {
    const DeviceInfo: any = await Http.DeviceInfo();

    device_info.gaid = DeviceInfo.GOOGLE_AD_ID;
    device_info.android_id = DeviceInfo.ANDROID_ID;
  }
  return device_info;
};

const getUserInfo = () => {
  const master_id =
    store.getters[types.GETTER_MASTER_ID] ||
    store.getters[types.GETTER_DEVICE_ID];
  // const master_name = store.getters[types.GETTER_MASTER_ID]
  //   ? store.getters[types.GETTER_INS_USER_INFO_BY_ID](master_id).insUserInfo
  //       .username
  //   : store.getters[types.GETTER_DEVICE_ID];
  const master_name = store.getters[types.GETTER_DEVICE_ID];
  const user_id = store.getters[types.GETTER_CURRENT_INS_USER_INFO]
    ? store.getters[types.GETTER_CURRENT_INS_USER_INFO].userId
    : store.getters[types.GETTER_DEVICE_ID];
  const username = store.getters[types.GETTER_CURRENT_INS_USER_INFO]
    ? store.getters[types.GETTER_CURRENT_INS_USER_INFO].userName
    : store.getters[types.GETTER_DEVICE_ID];
  return {
    master_id: master_id.toString(),
    master_name,
    user_id: user_id.toString(),
    username
    //TODO  user_id和username只有在给子账号买vip和订阅的时候需要
  };
};

// 获取url
const getStripeConfig: any = () => {
  if (process.env.NODE_ENV === "development") {
    return {
      stripe_key: "pk_test_8XhB5VRcHU3rYIB0Hb1ddatH",
      stripe_url: "https://hbtest.wefollow.co"
    };
  } else if (process.env.NODE_ENV === "production") {
    return {
      stripe_key: store.getters[types.GETTER_SETTING_DATA].stripe.stripe_key,
      stripe_url: store.getters[types.GETTER_SETTING_DATA].stripe.stripe_url
    };
  }
};

/**
 * iap的购买
 * @param offer
 * @param resource
 * @param
 */
export const payByIap = (offer: any, resource: any, retryParams?: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      let purchaseResult: any;

      //如果是重试进来的直接post offer:
      if (retryParams) {
        try {
          console.log("payByIap retryParams:", retryParams);
          // throw {
          //   status: "fail",
          //   error: { NSLocalizedDescription: "The request timed out." },
          //   code: -1001
          // };
          const result = await gxRequest.post(
            gxConst.kGetXApiPathOffer(offer.offer_id),
            retryParams
          );
          sendGXSuccess("postOffer");
          sendEventForBuy();
          console.log("payByIap retryParams result:", result);
          resolve(result);
          return;
        } catch (error) {
          //重试发现错误，不做dispath
          sendGXError(error, "postOffer");
          reject(error);
          return;
        }
      }

      if (isIos()) {
        //superpay版本以后的ios的iap换了接口
        const checkSuperPayWayInterfaceEnable = await store.dispatch(
          types.CHECK_SUPER_PAY_WAY_CAN_USE
        );
        if (checkSuperPayWayInterfaceEnable) {
          purchaseResult = await Http.IapPurchase({
            productId: offer.iap && offer.iap.product_id,
            offerId: offer.offer_id,
            resource
          });
        } else {
          purchaseResult = await Http.IapPurchase(
            offer.iap && offer.iap.product_id
          );
        }
      } else {
        //安卓需要整个offer：
        //offer需要重定义字段
        if (offer.hasOwnProperty("free_days")) {
          offer.freeDays = offer.free_days;
        }
        purchaseResult = await Http.IapPurchase(offer);
      }

      console.log("PAY_BY_IAP result", purchaseResult);

      if (purchaseResult.status !== "fail") {
        //购买成功

        let params: any;
        const device_info: any = await getDeviceInfo();
        const plan = addVipPlanParam(offer);
        if (isIos()) {
          //IOS:
          params = {
            user_info: getUserInfo(),
            offer,
            resource,
            receipt: purchaseResult.receipt,
            way: offer.way,
            transaction_id: purchaseResult.transaction_id,
            anonymous: GeneralUtilsHelper.isVisitor(),
            device_info
          };
        } else {
          //Android:
          params = {
            user_info: getUserInfo(),
            offer,
            resource,
            receipt: {
              ...purchaseResult.purchaseInfo.purchaseData,
              is_subscription: GeneralUtilsHelper.isSubsOffer(offer),
              signature: purchaseResult.purchaseInfo.signature
            },
            signature: purchaseResult.purchaseInfo.signature,
            way: offer.way,
            transaction_id:
              purchaseResult.purchaseInfo &&
              purchaseResult.purchaseInfo.purchaseData.orderId,
            anonymous: GeneralUtilsHelper.isVisitor(),
            device_info
          };
        }
        if (plan && plan.length > 0) {
          params.plan = plan;
        }

        params.product_id = offer.pay_data.iap.product_id;

        params.price = offer.pay_data.iap.price.slice(1);
        params.currency_code = "USD";
        cacheParams = params; //缓存params

        // throw {
        //   status: "fail",
        //   error: { NSLocalizedDescription: "The request timed out." },
        //   code: -1001
        // };

        console.log("params:>>>", params);
        const result = await gxRequest.post(
          gxConst.kGetXApiPathOffer(offer.offer_id),
          params
        );
        sendGXSuccess("postOffer");
        sendEventForBuy();

        try {
          if (isIos()) {
            //IOS的iap打点
            Http.IapEvent({
              productId: offer.iap.product_id,
              price: store.getters[types.GETTER_LOCALIZE_PRICE](
                offer.iap.product_id
              )
                ? store.getters[types.GETTER_LOCALIZE_PRICE](
                    offer.iap.product_id
                  ).price
                : parseFloat(offer.iap.price.substring(1)),
              currencyCode: store.getters[types.GETTER_LOCALIZE_PRICE](
                offer.iap.product_id
              )
                ? store.getters[types.GETTER_LOCALIZE_PRICE](
                    offer.iap.product_id
                  ).localSymbol
                : "$",
              isSubscribe: GeneralUtilsHelper.isSubsOffer(offer)
            });
          }
        } catch (error) {}

        resolve(result);
        sendRecomdOfferEvent();
      } else {
        //购买失败

        reject(purchaseResult);
      }
    } catch (error) {
      console.log("payByIap error:", error);
      sendGXError(error, "postOffer");
      //如果是请求超时，需要缓存到store,所有的订单：
      store.dispatch(types.PAYMENT_NET_ERROR_HANDLE, {
        error,
        retryParams: cacheParams,
        pay_way: "iap"
      });
      reject(error);
    }
  });
};

export const payBySuperPay = (offer: any, resource: any, pay_way?: string) => {
  return new Promise(async (resolve, reject) => {
    try {
      //原生的购买：
      offer = JSON.parse(JSON.stringify(offer));

      if (isIos()) {
        //从监听执行回调：
        Http.V3PostOfferBlock(async ({ response, callBack }: any) => {
          // resultResolve(IapSuperPayResult);
          try {
            EventBus.$emit("toast-show", {
              type: "loading",
              content: "processing…",
              duration: "infinite"
            });

            console.log("V3PostOfferBlock：", {
              response,
              callBack
            });
            const result = JSON.parse(response);

            superPayResponse({
              response: result,
              from: "native",
              pay_way
            }); //原生打点

            if (result.status && result.status === "ok") {
              console.log("结果123123:", JSON.parse(result.msg));
              const iapResult = JSON.parse(result.msg);
              console.log("123123123");

              const plan = addVipPlanParam(offer);

              const params: any = {
                pay_platform: iapResult.jumpMap.pay_platform,
                offer_id: offer.offer_id,
                master_id: getUserInfo().master_id,
                target_user_id:
                  offer.kind.indexOf("vip") > -1
                    ? getUserInfo().master_id
                    : getUserInfo().user_id,
                resource,
                receipt: iapResult.receipt.data,
                transaction_id: iapResult.transaction_id
              };
              if (plan.length > 0) {
                params.plan = plan;
              }
              //添加pay_way
              if (pay_way) {
                params.pay_way = pay_way;
              }

              console.log("params V3PostOfferBlock：", params);

              const postResult = await gxRequest.post(
                gxConst.kGetXApiPostOfferV3,
                params
              );
              sendGXSuccess("postOfferV3");
              console.log("payBySuperPay result:", postResult);

              store.dispatch(types.SUPER_PAY_RESULT_PROCESS, postResult);

              //打点
              superPayResponse({
                response: result,
                from: "server",
                pay_way
              });
            } else {
              //返回失败：
              store.dispatch(types.PAYMENT_ERROR_TOAST_HANDLE, {
                error: result
              });
            }
          } catch (error) {
            sendGXError(error, "postOfferV3");
            store.dispatch(types.PAYMENT_ERROR_TOAST_HANDLE, {
              error
            });
            //打点
            superPayResponse({
              response: error,
              from: "server",
              pay_way
            });
            console.log("V3PostOfferBlock error:", error);
          }
        });
      } else {
        try {
          //安卓:
          if (
            pay_way === "super_pay" &&
            store.getters[types.GETTER_SUPER_PAY_APP_CONFIG] &&
            store.getters[types.GETTER_SUPER_PAY_APP_CONFIG].packageName
          ) {
            offer.preferPackage =
              store.getters[types.GETTER_SUPER_PAY_APP_CONFIG].packageName;
          } else {
            if (store.getters[types.GETTER_BACK_UP_APP_CONFIG]) {
              offer.preferPackage =
                store.getters[types.GETTER_BACK_UP_APP_CONFIG].packageName;
            }
          }

          if (
            pay_way === "super_pay" &&
            offer.pay_data &&
            offer.pay_data.super_pay
          ) {
            //只有superpay才会取pay_data里面的字段，用于减价
            offer.actual_price = offer.pay_data.super_pay.price;
          } else {
            offer.actual_price = offer.iap.price;
            //如果back up 有
            if (
              offer.pay_data &&
              offer.pay_data.super_pay &&
              offer.iap &&
              offer.iap.price
            ) {
              offer.pay_data.super_pay.price = offer.iap.price;
            }
          }
          console.log("IapSuperPay offer", offer);
          const purchaseResult: any = await Http.IapSuperPay(offer);
          console.log("superpay purchaseResult ==>", purchaseResult);

          //打点
          superPayResponse({
            response: purchaseResult,
            from: "native",
            pay_way
          });

          //post offer v3:
          if (purchaseResult.status !== "fail") {
            EventBus.$emit("toast-show", {
              type: "loading",
              content: "processing…",
              duration: "infinite"
            });

            //Android：
            const purchaseDetailData = purchaseResult.tran;
            const receipt = JSON.stringify({
              ...purchaseDetailData.purchaseInfo.purchaseData,
              is_subscription: GeneralUtilsHelper.isSubsOffer(offer),
              signature: purchaseDetailData.purchaseInfo.signature
            });

            const plan = addVipPlanParam(offer);

            let params: any = {
              pay_platform: purchaseResult.payPlatform,
              offer_id: offer.offer_id,
              master_id: getUserInfo().master_id,
              target_user_id:
                offer.kind.indexOf("vip") > -1
                  ? getUserInfo().master_id
                  : getUserInfo().user_id,
              resource,
              receipt,
              transaction_id:
                purchaseDetailData.purchaseInfo &&
                purchaseDetailData.purchaseInfo.purchaseData.orderId
            };
            if (plan.length > 0) {
              params.plan = plan;
            }
            if (judgeVersion(getAppVersion(), "4.9.0")) {
              const device_info: any = await getDeviceInfo();
              const AppInfo: any = await Http.AppInfo();
              const platform: any = AppInfo.GETX_PLATFORM;
              const app_version: any = AppInfo.VERSION_NAME;
              params = {
                ...params,
                platform,
                app_version,
                device_info
              };
            }
            //添加pay_way
            if (pay_way) {
              params.pay_way = pay_way;
            }
            params.product_id = offer.pay_data.iap.product_id;

            params.price = offer.pay_data.iap.price.slice(1);
            params.currency_code = "USD";

            console.log("sp post offer params:>>>", params);
            const result = await gxRequest.post(
              gxConst.kGetXApiPostOfferV3,
              params
            );
            sendGXSuccess("postOfferV3");
            console.log("payBySuperPay result:", result);

            resolve(result);

            //打点
            superPayResponse({
              response: result,
              from: "server",
              pay_way
            });
          } else {
            reject(purchaseResult);
          }
        } catch (error) {
          sendGXError(error, "postOfferV3");
          reject(error);
          superPayResponse({
            response: error,
            from: "server",
            pay_way
          });
        }
      }
    } catch (error) {
      reject(error);
    }
  });
};
/**
 * paypal的购买
 * @param offer
 * @param resource
 * @param isSubscription
 */
export const payByPayPal = (
  offer: any,
  resource: any,
  isSubscription = false
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let result: any;
      if (isIos()) {
        //IOS的购买
        const master_id =
          store.getters[types.GETTER_MASTER_ID] ||
          store.getters[types.GETTER_DEVICE_ID];
        result = await Http.IapPayPal({
          offer,
          resource,
          masterId: master_id.toString()
        });
      } else {
        //Android的购买:
        //如果是订阅类型传参与普通不一致：
        const offerInfo = store.getters[types.GETTER_INFO_BY_OFFER_DATA](
          offer,
          "paypal"
        );
        const paypay_price =
          offer &&
          offer.pay_data &&
          offer.pay_data.paypal &&
          offer.pay_data.paypal.price;
        const price_desc =
          paypay_price &&
          store.getters[types.GETTER_PAYPAL_PRICE_DESC](paypay_price);
        // vip 需要加10%的数量：
        let description: any = `${
          offerInfo.reward_effect > 0
            ? offerInfo.reward_effect + offerInfo.effect
            : "" + offerInfo.effect
        }`;

        if (
          GeneralUtilsHelper.isVip() &&
          !GeneralUtilsHelper.isSubsOffer(offer) &&
          !(offer.kind.indexOf("coin") > -1)
        ) {
          description = Math.floor(
            parseFloat(description) + parseFloat(description) * 0.1
          );
        }
        description =
          price_desc && !isIos() && judgeVersion(getAppVersion(), "4.9.0")
            ? price_desc
            : description;
        description = String(description);
        console.log("description paypal==>", description);
        let purchaseResult: any;

        //如果是订阅类型：
        if (GeneralUtilsHelper.isSubsOffer(offer)) {
          // paypal处理userInfo,如果有user_id，则转成master_id
          const userInfo = getUserInfo();
          if (userInfo && userInfo.user_id) {
            userInfo.user_id = userInfo.username = userInfo.master_id;
          }
          result = await Http.IapPayPalSubscribe({
            userInfo,
            offer,
            resource
          });
        } else {
          purchaseResult = await Http.IapPayPal({
            offer,
            description
          });

          console.log("IapPayPal purchaseResult:", purchaseResult);

          if (purchaseResult.status === "fail") {
            reject(purchaseResult);
          }
          sendRecomdOfferEvent();
          const params = {
            user_info: getUserInfo(),
            offer,
            resource,
            paypal_data: purchaseResult.purchaseInfo,
            way: offer.way,
            transaction_id:
              purchaseResult.purchaseInfo.response &&
              purchaseResult.purchaseInfo.response.id,
            anonymous: GeneralUtilsHelper.isVisitor(),
            paypal_metadata_id: purchaseResult.paypalMetaId,
            pp_flag: getPaypalClientId()
          };

          cacheParams = params; //缓存params
          console.log(" payByPayPal post offer params", params);
          result = await gxRequest.post(
            gxConst.kGetXApiPathOffer(offer.offer_id),
            params
          );
          sendGXSuccess("postOffer");
          sendEventForBuy();
          //默认的请求做了status判断，而IOS没做
          // resolve(result);
        }
      }
      console.log("purchaseInfoString---", result);
      if (result.status === "fail") {
        reject(result);
      } else {
        sendRecomdOfferEvent();
        resolve(result);
      }
    } catch (error) {
      sendGXError(error, "postOffer");
      store.dispatch(types.PAYMENT_NET_ERROR_HANDLE, {
        error,
        retryParams: cacheParams,
        pay_way: "paypal"
      });
      reject(error);
    }
  });
};

export const payByCreditCard = (
  offer: any,
  resource: any,
  isSubscription = false
) => {
  console.log("payByCreditCard*************", offer);
  return new Promise(async (resolve, reject) => {
    try {
      let result: any;
      // 判断ios还是安卓，ios直接进入网页支付流程，安卓进入stripe页面
      if (isIos()) {
        const convertKind = store.getters[types.GETTER_INFO_BY_OFFER_DATA](
          offer
        ).type_name;
        const price = offer.pay_data
          ? offer.pay_data.paypal && offer.pay_data.paypal.price
          : offer.iap && offer.iap.price;
        const effect = offer.pay_data
          ? offer.pay_data.paypal && offer.pay_data.paypal.effect
          : offer.webp_effect;
        const master_id =
          store.getters[types.GETTER_MASTER_ID] ||
          store.getters[types.GETTER_DEVICE_ID];

        result = await Http.IapCreditCard({
          offer,
          resource,
          masterId: master_id.toString()
        });
        console.log("purchaseInfo IapCreditCard:", result);
      } else {
        const info: any = await Http.IapCreditCard(offer.cardObj);
        console.log("paybyceaditcart*************", offer);
        if (info.status === "fail") {
          console.log(info);
          reject(info);
        } else {
          //  获取APP的相关信息
          const AppInfo: any = await Http.AppInfo();
          const receipt = {
            stripe_token: info
          };

          const params = {
            user_info: getUserInfo(),
            offer_id: offer.offer.offer_id,
            receipt,
            anonymous: GeneralUtilsHelper.isVisitor(),
            feed_data: "",
            offer_platform: AppInfo.GETX_PLATFORM,
            primary_platform: AppInfo.GETX_PLATFORM
          };
          if (resource) {
            params.feed_data = resource;
          }

          cacheParams = params; //缓存params

          // console.log("qsStringify(params):", qsStringify(params));

          const extra = {
            encryptHandle: false
          };

          result = await gxRequest.post(
            getStripeConfig().stripe_url + "/mobile/post_offer",
            params,
            extra
          );
          sendGXSuccess("stripePostOffer");
        }
      }
      console.log("payByCreditCard result:", result);
      //stripe的http请求没有做默认请求
      if (result.status === "fail") {
        reject(result);
      } else {
        sendRecomdOfferEvent();
        resolve(result);
      }
    } catch (error) {
      sendGXError(error, "stripePostOffer");
      store.dispatch(types.PAYMENT_NET_ERROR_HANDLE, {
        error,
        retryParams: cacheParams,
        pay_way: "card"
      });
      reject(error);
    }
  });
};

/**
 * 金币的购买
 * @param offer
 * @param resource
 */
export const payByCoins = (offer: any, resource: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const master_id =
        store.getters[types.GETTER_MASTER_ID] ||
        store.getters[types.GETTER_DEVICE_ID];
      const master_name = store.getters[types.GETTER_DEVICE_ID];
      // store.getters[types.GETTER_INS_USER_INFO_BY_ID](
      //   master_id
      // ).insUserInfo.username;
      const device_info: any = await getDeviceInfo();
      console.log("device_info:", device_info);

      const params = {
        user_info: {
          master_id: master_id.toString(),
          master_name
        },
        offer,
        resource,
        way: offer.way,
        transaction_id: defaultTransactionId(),
        receipt: {},
        device_info
      };
      console.log("postOffer params:", params);
      const result = await gxRequest.post(
        gxConst.kGetXApiPathOffer(offer.offer_id),
        params
      );
      sendGXSuccess("postOffer");
      sendEventForBuy();
      if (result.status === "fail") {
      } else {
        sendRecomdOfferEvent();
      }

      resolve(result);
    } catch (e) {
      sendGXError(e, "postOffer");
      reject(e);
    }
  });
};

/**
 * 获取order list
 * @param userId
 * @param nextCursor
 */
export const getOrder = (userId: any, nextCursor?: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const params: any = {};
      if (nextCursor !== undefined && nextCursor !== null) {
        params.next_cursor = nextCursor;
      }
      const result = await gxRequest.get(
        gxConst.kGetXApiPathIapHistory(userId),
        params
      );
      sendGXSuccess("getOrder");
      console.log("getOrder:result:", result);
      resolve(result);
      try {
        //判断是否有processing的订单
        const dataList = result.data || result;
        for (const value of dataList) {
          if (!value.finished) {
            return;
          }
          localStorageHelper.remove("order-processing-data");
        }
        //如果没有porcessing通知，删除本地记录
        localStorageHelper.remove("order-processing-data");
      } catch (err) {}
    } catch (error) {
      sendGXError(error, "getOrder");
      reject(error);
    }
  });
};

/**
 * Post Offer
 * @param params
 */
export const postOffer = (params: any) => {
  const { offer_id } = params.offer;
  return new Promise(async (resolve, reject) => {
    try {
      const result = await gxRequest.post(
        gxConst.kGetXApiPathOffer(offer_id),
        params
      );
      sendGXSuccess("postOffer");
      resolve(result);
    } catch (e) {
      sendGXError(e, "postOffer");
      reject(e);
    }
  });
};

/*
 * 支付类型的打点
 * */
const sendEventForBuy = () => {
  if (eventObj) {
    console.log("eventObj", eventObj);
    sendEvent(eventObj.key, eventObj.value);
    updateEventObj(null);
  }
};

const addVipPlanParam = (offer: any) => {
  const isVip = offer.kind.indexOf("vip") > -1;
  if (!isVip) {
    return "";
  }
  const plan = LaunchUtils.getBuyVipFrom();
  LaunchUtils.clearBuyVipFrom();
  return plan;
};
